import { createSelector } from "reselect";
import { partnersSelector } from "../partners_selector";

export const partnersDataSelector = createSelector(
  partnersSelector,
  partners => partners.data
);
